/**
 * Configuração de ícones para tipos de conteúdo no Volto
 */
import agendaSVG from '../icons/agenda.svg';
import diagramHierarchySVG from '../icons/diagram-hierarchy.svg';
import clockSVG from '@plone/volto/icons/clock.svg';
import eventSVG from '@plone/volto/icons/event.svg';
import userSVG from '@plone/volto/icons/user.svg';

export const contentIcons = {
  Pessoa: userSVG,
  Area: diagramHierarchySVG,
  Agenda: agendaSVG,
  AgendaDiaria: eventSVG,
  Compromisso: clockSVG,
};
